var StyleSheet = /** @class */ (function () {
    function StyleSheet(content, onLoad) {
        this.sheet = document.createElement('style');
        if (content)
            this.setContent(content);
        document.body.appendChild(this.sheet);
        this.sheet.addEventListener('load', function () {
            onLoad && onLoad();
        });
    }
    StyleSheet.prototype.setContent = function (content) {
        this.sheet.innerHTML = content;
    };
    return StyleSheet;
}());
export { StyleSheet };
